import React, { useEffect, useContext, useState } from 'react';
import Icon_Close from '../../../Assets/Icons/Icon_Close.png';
import Icon_Schedule from '../../../Assets/Icons/Icon_Color_Schedule.png';
import { Context_UI } from '../../../Contexts/Context_UI';
import { useScheduleManagement } from '../../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../../Contexts/Context_MapRenderer';
import UI_Card from '../../ERUMAUI/UI_Card';
import UI_ChipGroup from '../../ERUMAUI/UI_ChipGroup';
import { useAccounts } from '../../../Contexts/Context_Accounts';
import UI_Dropdown from '../../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../../Contexts/Context_Templating';
import { useStatus } from '../../../Contexts/Context_Status_Global';
import UI_Divider from '../../ERUMAUI/UI_Divider';
import UI_Form from '../../ERUMAUI/UI_Form';
import UI_Input_Text from '../../ERUMAUI/UI_Input_Text';
import UI_Input_Date from '../../ERUMAUI/UI_Input_Date';
import UI_Input_Time from '../../ERUMAUI/UI_Input_Time';
import UI_UpdatingStatus from '../../ERUMAUI/UI_UpdatingStatus';

export default function Subwindow_Modal_Schedule_Reschedule({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Schedule_Information, Schedule_Information_Set, Time_Range_Parse, Schedule_Action_Mode, Status_Parse, Time_Parse, Conflicts, Conflict_Check, Conflict_Recommendation } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const { Account_Fetch_ByID_Basic } = useAccounts();
    const [Account, Account_Set] = useState({ Name: "", Email: "" });
    const { Template_List } = useTemplating();
    const { Confirmer_Respond } = useStatus();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    const [Schedule_Information_Old, Schedule_Information_Old_Set] = useState(Schedule_Information);
    const [Schedule_Information_Loaded, Schedule_Information_Loaded_Set] = useState(false);

    useEffect(() => {
        if (Schedule_Information_Loaded == false) {
            Schedule_Information_Old_Set(Schedule_Information);
            Schedule_Information_Loaded_Set(true);
        }

    }, []);


    useEffect(() => {
        Fetch(Schedule_Information.Requester.RequesterID)
    }, [Schedule_Information]);

    useEffect(() => {
        document.getElementById("Reschedule_Reason").querySelector(".Dropdown_Button").click();
        // console.log(Format_Time(Schedule_Information.Time.Start, "time"));
    }, []);

    const Fetch = async (ID) => {
        const Data = await Account_Fetch_ByID_Basic(ID);
        Account_Set(Data);
    }

    const Confirm = async () => {
        const Cleared = await UI.Input_Evaluate([
            {
                ID_Start: "Schedule_Start",
                ID_End: "Schedule_End",
                Type: "Time_Range",
                AC: "Past",
                Prompt: "Invalid time range."
            },
            {
                ID: "Reschedule_Reason",
                Type: "Dropdown",
                AC: "No reschedule reason specified",
                Prompt: "Specifying a reason is required."
            }
        ])
        if (Cleared) {
            // console.log(Cleared);
            Confirmer_Respond(true, {
                Reason: document.getElementById("Reschedule_Reason").querySelector(".Dropdown_Button").querySelector(".Dropdown_Button_Text").innerText,
                Time_Start: UpdatedSchedule.Start,
                Time_End: UpdatedSchedule.End,
                Date: UpdatedSchedule.Date
            }, true, "Window_ScheduleManagement_Schedule_Reschedule");
        }

        // UI.Subwindows_Close('Window_MapEditor_RippleDelete');
    }

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_ScheduleManagement_Schedule_Reschedule");
    }

    const Format_Time = (dateTemp, Type) => {
        const date = new Date(dateTemp);
        if (!(date instanceof Date) || isNaN(date)) return "?";
        const pad = (n) => String(n).padStart(2, "0");
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        switch (Type) {
            case "date":
                return `${year}-${month}-${day}`;
            case "time":
                return `${hours}:${minutes}`;
            case "datetime-local":
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            default:
                return "";
        }
    }

    const Suggestion_Accept = (Data, Type) => {
        if (Type === "Time") {
            const Start = new Date(Data.Start);
            const End = new Date(Data.End);

            setUpdatedSchedule(prev => ({
                ...prev,
                Start: Start,
                End: End,
                Date: Start
            }));
        }
    }

    const Handle_Change = (Keys, Value) => {
        const Update = (Previous, Keys, Value) => {
            if (Keys.length === 1) {
                return { ...Previous, [Keys[0]]: Value };
            }
            const [Key_Current, ...Keys_Rest] = Keys;
            return {
                ...Previous,
                [Key_Current]: Update(Previous[Key_Current], Keys_Rest, Value)
            };
        }
        Schedule_Information_Set(Previous => Update(Previous, Keys, Value));
    }

    const Handle_Time_Change = async (e) => {
        const { id, value } = e.target;

        Schedule_Information_Set((prev) => {
            let newStart = new Date(prev.Time.Start);
            let newEnd = new Date(prev.Time.End);

            if (id === "Schedule_Date") {
                // Update both Start & End with new date, preserve hours/minutes
                const [year, month, day] = value.split("-").map(Number);
                newStart.setFullYear(year, month - 1, day);
                newEnd.setFullYear(year, month - 1, day);
            }

            if (id === "Schedule_Start") {
                const [hours, minutes] = value.split(":").map(Number);
                newStart.setHours(hours, minutes, 0, 0);
            }

            if (id === "Schedule_End") {
                const [hours, minutes] = value.split(":").map(Number);
                newEnd.setHours(hours, minutes, 0, 0);
            }

            return {
                ...prev,
                Time: {
                    Start: newStart,
                    End: newEnd,
                },
                DateModified: new Date()
            };
        });
        // await Conflict_Check();
    };

    const [UpdatedSchedule, setUpdatedSchedule] = useState({
        Start: new Date(),
        End: new Date(),
        Date: new Date()
    });

    useEffect(() => {
        if (Schedule_Information?.Time) {
            setUpdatedSchedule({
                Start: Schedule_Information.Time.Start,
                End: Schedule_Information.Time.End,
                Date: Schedule_Information.Time.Start,
            });
        }
    }, [Schedule_Information]);

    useEffect(() => {
        if (UpdatedSchedule && Schedule_Information) {
            Conflict_Check("Temporary", {
                RoomID: Schedule_Information.RoomID,
                Time: {
                    Start: UpdatedSchedule.Start,
                    End: UpdatedSchedule.End
                },
                ScheduleID: Schedule_Information._id
            });
        }
    }, [UpdatedSchedule, Schedule_Information]);

    const Handle_Time_Update = (Value, Type) => {
        if (Type === "Start") {
            const [hours, minutes] = Value.split(":").map(Number);
            setUpdatedSchedule(prev => {
                const newDate = new Date(prev.Start);
                newDate.setHours(hours, minutes, 0, 0);
                return { ...prev, Start: newDate };
            });
        } else if (Type === "End") {
            const [hours, minutes] = Value.split(":").map(Number);
            setUpdatedSchedule(prev => {
                const newDate = new Date(prev.End);
                newDate.setHours(hours, minutes, 0, 0);
                return { ...prev, End: newDate };
            });
        } else if (Type === "Date") {
            const [year, month, day] = Value.split("-").map(Number);
            setUpdatedSchedule(prev => {
                const newStart = new Date(prev.Start);
                const newEnd = new Date(prev.End);
                newStart.setFullYear(year, month - 1, day);
                newEnd.setFullYear(year, month - 1, day);
                return { ...prev, Date: newStart, Start: newStart, End: newEnd };
            });
        }
    }

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})} style={{ height: "calc(100% - 20px)" }}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px", alignItems: "center" }}>
                    <div className='Subwindow_Content_Icon'>
                        <img src={Icon_Schedule} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                    </div>
                    <div>
                        <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Reschedule
                        </h2>

                        <p className='General_Paragraph' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Please specify a new time and date for the request. You cannot reschedule this activity if it conflicts with other activities.
                        </p>
                    </div>
                </div>
                <div className='General_Split' Split="3">
                    <div>
                        <UI_Card Type="Panel_Info" Text="Name" Figure={Schedule_Information.Name} />
                        <UI_Card Type="Panel_Info" Text="Requested time" Figure={Time_Range_Parse(Schedule_Information.Time.Start, Schedule_Information.Time.End)} />
                        <UI_Card Type="Panel_Info" Text="Requested location" Figure={Room_Get_Address(Schedule_Information.RoomID)} />
                        <UI_Card Type="Panel_Info" Text="Type of activity" Figure={Schedule_Information.Activity.Type} />
                        <UI_Card Type="Panel_Info" Text="Requestant's name" Figure={Account.Name} />
                        <UI_Card Type="Panel_Info" Text="Requestant's email" Figure={Account.Email} />
                        <UI_Card Type="Panel_Info" Text="Number of attendees" Figure={Schedule_Information.Activity.Attendees.Names.length} />
                        <div className='AM_Details_Data' id={id}>
                            <p className='General_Paragraph'>
                                Reservation status
                            </p>
                            <UI_ChipGroup Items={Status_Parse(Schedule_Information)} />
                        </div>
                    </div>
                    <div>
                        <UI_Divider Text="Original schedule" />
                        <UI_Form Composition="ByTwo">
                            <UI_Input_Text
                                id="Schedule_Start_Changeable"
                                Label_Text="Start time:"
                                Input_Type='time'
                                Value_Set_Enable={true}
                                Value={Format_Time(Schedule_Information.Time.Start, "time")}
                                disabled={true}
                            />
                            <UI_Input_Text
                                id="Schedule_End_Changeable"
                                Label_Text="End time:"
                                Input_Type='time'
                                Value_Set_Enable={true}
                                Value={Format_Time(Schedule_Information.Time.End, "time")}
                                disabled={true}
                            />
                            <UI_Input_Text
                                id="Schedule_Date_Changeable"
                                Label_Text="Date:"
                                Input_Type='date'
                                Value_Set_Enable={true}
                                Value={Format_Time(Schedule_Information.Time.Start, "date")}
                                PreventPast={true}
                                disabled={true}
                            />
                        </UI_Form>
                        <UI_Divider Text="Updated schedule" />
                        <UI_Form Composition="ByTwo">
                            <UI_Input_Text
                                id="Schedule_Start"
                                Label_Text="Start time:"
                                Input_Type="time"
                                Value_Set_Enable={true}
                                Value={Format_Time(UpdatedSchedule.Start, "time")}
                                onChange={(e) => {
                                    Handle_Time_Update(e.target.value, "Start");

                                }}
                            />
                            {/* <UI_Input_Time 
                                id="Schedule_Start"
                                Label_Text="Start time:"
                                Value={Format_Time(UpdatedSchedule.Start, "time")}
                                Value_Set_Enable={true}
                                onChange={(e) => {
                                    Handle_Time_Update(e.target.value, "Start");
                                }}
                            /> */}

                            <UI_Input_Text
                                id="Schedule_End"
                                Label_Text="End time:"
                                Input_Type="time"
                                Value_Set_Enable={true}
                                Value={Format_Time(UpdatedSchedule.End, "time")}
                                onChange={(e) => {
                                    Handle_Time_Update(e.target.value, "End");
                                }}
                            />

                            {/* <UI_Input_Time
                                id="Schedule_End"
                                Label_Text="End time:"
                                Value={Format_Time(UpdatedSchedule.End, "time")}
                                onChange={(e) => {
                                    Handle_Time_Update(e.target.value, "End");
                                }}
                            /> */}

                            <UI_Input_Text
                                id="Schedule_Date"
                                Label_Text="Date:"
                                Input_Type="date"
                                Value_Set_Enable={true}
                                Value={Format_Time(UpdatedSchedule.Date, "date")}
                                PreventPast={true}
                                onChange={(e) => {
                                    Handle_Time_Update(e.target.value, "Date");
                                }}
                            />

                        </UI_Form>
                        <div className='AM_Details_Data' id={id}>
                            <p className='General_Paragraph'>
                                Pick a reschedule reason
                            </p>
                            <UI_Dropdown id="Reschedule_Reason" Items={Template_List.Reason.Request_Rescheduled} InitialTitle="No reschedule reason specified" />
                        </div>
                    </div>
                    <div>
                        <UI_Divider Text="Conflicting schedules" />
                        <UI_UpdatingStatus
                            State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                            Good={{
                                Type: "Default",
                                Icon: "Default",
                                Title: "No schedule conflicts",
                                Text: "No schedule conflict detected. You can continue with your reservation."
                            }}
                            Bad={{
                                Type: "Custom",
                                Content: <div className='General_List'>
                                    {Conflicts.Hard.map((Item) => (
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={
                                                {
                                                    Title: Item.Name,
                                                    Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                    Chip: Status_Parse(Item)
                                                }
                                            }
                                        />
                                    ))}
                                    {Conflicts.Soft.map((Item) => (
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={
                                                {
                                                    Title: Item.Name,
                                                    Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                    Chip: Status_Parse(Item)
                                                }
                                            }
                                        />
                                    ))}
                                </div>
                            }}
                        />
                        <UI_Divider Text="Time slot suggestions" />
                        <UI_UpdatingStatus
                            State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                            Good={{
                                Type: "Default",
                                Icon: "Default",
                                Title: "No schedule conflicts",
                                Text: "No schedule conflict detected. You can continue with your reservation."
                            }}
                            Bad={{
                                Type: "Custom",
                                Content: <>
                                    {/* <p className='General_Paragraph' style={{ marginBottom: "20px" }}>
                                        Click a suggestion below to apply it to your reservation
                                    </p> */}
                                    <div className='General_List'>
                                        {Conflict_Recommendation?.Time?.map((Item) => (
                                            <UI_Card
                                                Type="Schedule_List"
                                                Figure={
                                                    {
                                                        Title: Time_Range_Parse(Item.Start, Item.End, "Time"),
                                                        Main: Time_Parse(Item.Start, "Date"),
                                                        Chip: []
                                                    }
                                                }
                                            // onClick={() => Suggestion_Accept(Item, "Time")}
                                            />
                                        ))}
                                    </div>
                                </>
                            }}
                        />
                    </div>

                </div>



            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                {Conflicts.Hard.length > 0 ?
                    <button className='General_Button Subwindow_Control' Type='Secondary'>
                        Resolve conflict to continue
                    </button>
                    :
                    <button className='General_Button Subwindow_Control' Type='Secondary' State="Neutral" onClick={Confirm}>
                        Reschedule
                    </button>
                }

            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
